import React from 'react';

import { danfeProducao } from './producao/danfeProducao';

/**
 * Componente principal para geração do layout do DANFE.
 * Deve ser utilizado dentro do `<PDFViewer>` (no browser) ou de funções de renderização PDF.
 *
 * @param {Object} props
 * @param {Object} props.objetoXML - O objeto com os dados mapeados (proveniente de converterXmlNfeParaJson)
 * @param {Object} [props.opcoes] - Opções de renderização opcionais (ex: exibirCanhoto)
 * @returns {React.ReactElement|null} Componente `<Document>` do react-pdf
 */
export function GerarDanfeNfe({ objetoXML, opcoes = {} }) {
  if (!objetoXML) {
    return null;
  }

  // A função danfeProducao constrói e retorna um componente React (DocumentoDanfe)
  // baseado nos dados fornecidos.
  const Documento = danfeProducao(objetoXML, opcoes);

  // Renderizamos o componente retornado
  return <Documento />;
}

export default GerarDanfeNfe;
